import script from "./Projects.vue?vue&type=script&setup=true&lang=js"
export * from "./Projects.vue?vue&type=script&setup=true&lang=js"

import "./Projects.vue?vue&type=style&index=0&id=7c822ee3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c822ee3"]])

export default __exports__